import useTemplateVariables, {
  AvailableVariableTypes,
} from 'components/domain/customData/useTemplateVariables';
import { RichTextEditorToolbarPluginProps } from 'components/editor/RichTextEditor.types';
import { MessagingType } from 'models/automation/SystemTemplates';

interface UseMessageLogToolbarSettingsProps {
  messagingType?: MessagingType;
}

const EMAIL_VARIABLE_TYPES: AvailableVariableTypes[] = [
  'agency',
  'custom',
  'guest',
  'lead',
  'message',
  'order',
  'property',
];

const TEXT_VARIABLE_TYPES: AvailableVariableTypes[] = [
  'agency',
  'custom',
  'guest',
  'lead',
  'property',
];

const useMessageLogToolbarSettings = ({
  messagingType,
}: UseMessageLogToolbarSettingsProps) => {
  const isEmailType = messagingType === MessagingType.EMAIL;

  const { variables, isLoading: isLoadingVariables } = useTemplateVariables(
    isEmailType ? EMAIL_VARIABLE_TYPES : TEXT_VARIABLE_TYPES,
  );

  const toolbarSettings: RichTextEditorToolbarPluginProps['toolbarSettings'] = {
    enabled: true,
    features: {
      bold: isEmailType,
      cleanHTML: isEmailType,
      editHTML: isEmailType,
      fontFamily: isEmailType,
      italic: isEmailType,
      link: isEmailType,
      lists: isEmailType,
      quote: isEmailType,
      textAlignment: isEmailType,
      textColor: isEmailType,
      underline: isEmailType,
      variables,
    },
  };

  return {
    toolbarSettings,
    isLoadingVariables,
  };
};

export default useMessageLogToolbarSettings;
